"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Loader2, Languages, Trash2, Download, Upload, RefreshCw } from "lucide-react"
import { useLanguage } from "@/contexts/language-context"

export function TranslationStatus() {
  const { currentLanguage } = useLanguage()
  // 注释掉API翻译相关功能
  // const { currentLanguage, isTranslating, translatePage, clearTranslationCache } = useLanguage()
  const [showAdvanced, setShowAdvanced] = useState(false)

  // 暂时隐藏翻译状态组件，因为已禁用API翻译
  return null // 功能暂时禁用，移除后续未定义标识符引用避免 TS 报错
} 